
import React from 'react';

const UploadHeader = () => {
  return (
    <header className="bg-slate-700 text-white py-6">
      <div className="container mx-auto px-4">
        <h1 className="text-2xl font-bold text-center mb-1">gerball.co.uk</h1>
        <p className="text-center text-gray-300">Football Data Analysis</p>
      </div>
    </header>
  );
};

export default UploadHeader;
